var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
import { __decorate, __metadata } from "tslib";
import { ElMessage } from 'element-plus';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Pagination } from '@/core/enums/Pagination';
import ApiService from '@/core/services/ApiService';
import { dynamicSort } from '@/core/helpers/table-sort';
import { Actions, Mutations } from '@/store/enums/hrgs/master/PreAssessementEnum';
import TMasterPreAssessmentList from '@/core/types/entities/hrgs/master/pre-assessment-schedule/PreAssessmentScheduleEntities';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    getAll: `${API_URL}/api/preassessments`
};
let MasterPreAssessmentListModule = class MasterPreAssessmentListModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.pageName = 'MasterPreAssessmentPage';
        this.masterPreAssessmentList = new Array({
            asesiName: '',
            assessmentCode: '',
            assessmentId: '',
            assessorName: '',
            meetingLink: '',
            meetingSchedule: new Date(),
            schemeTitle: '',
            testPlaceName: ''
        });
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1,
            loading: false
        };
        this.filters = {
            date: null,
            schemeId: null,
            testPlaceId: null,
            asesiName: null,
            assessorName: null
        };
        this.loading = false;
        this.isFiltered = false;
        this.modalLoading = false;
        this.orderBy = null;
    }
    // *GETTERS
    get getMasterPAList() {
        return this.masterPreAssessmentList;
    }
    get getMasterPAPageName() {
        return this.pageName;
    }
    get getMasterPAPagination() {
        return this.pagination;
    }
    get getIsMasterPADataListLoading() {
        return this.loading;
    }
    get getIsModalPALoading() {
        return this.modalLoading;
    }
    get getPANonNullFilter() {
        return Object.fromEntries(Object.entries(this.filters).filter(([, value]) => {
            return value !== null;
        }));
    }
    // *MUTATIONS
    [_a = Mutations.SET_MASTER_PA_LIST](data) {
        const newFormattedArr = data.map((element) => {
            return new TMasterPreAssessmentList(element);
        });
        this.masterPreAssessmentList = newFormattedArr;
    }
    [_b = Mutations.SET_LOADING](state) {
        this.loading = state;
    }
    [_c = Mutations.SET_MODAL_LOADING](state) {
        this.modalLoading = state;
    }
    [_d = Mutations.SET_PAGINATION_LOADING](state) {
        this.pagination.loading = state;
    }
    [_e = Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize),
            loading: false
        };
    }
    [_f = Mutations.SET_FILTER](data) {
        this.filters = Object.assign(Object.assign(Object.assign({}, this.filters), data), ((data === null || data === void 0 ? void 0 : data.date) && {
            date: data.date.toISOString()
        }));
    }
    [_g = Mutations.CLEAR_FILTER]() {
        // eslint-disable-next-line arrow-body-style
        Object.keys(this.filters).forEach((key) => (this.filters[key] = null));
    }
    [_h = Mutations.SET_ORDER](data) {
        this.orderBy = data;
    }
    // *ACTIONS
    [_j = Actions.GET_MASTER_PA_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.getAll}/${employeeID}/schedules?`;
        const params = Object.assign({ ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }, (this.orderBy && {
            orderBy: this.orderBy
        }));
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_LOADING, true);
            this.context.commit(Mutations.SET_PAGINATION_LOADING, true);
            ApiService.get(`${url}${new URLSearchParams(Object.assign(Object.assign({}, params), this.getPANonNullFilter)).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                const sortData = resData.data.sort(dynamicSort('asesiName', 'descending'));
                this.context.commit(Mutations.SET_MASTER_PA_LIST, sortData);
                this.context.commit(Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve();
            })
                .catch((error) => {
                ElMessage.error(error);
                reject();
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
                this.context.commit(Mutations.SET_PAGINATION_LOADING, false);
            });
        });
    }
    [_k = Actions.POST_SCHEDULE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload;
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.getAll}/${employeeID}/${payload.assessmentId}/schedules?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed create pre assessment schedules.'
                });
                reject(_response);
            });
        });
    }
    [_l = Actions.UPDATE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            approvalBy: payload === null || payload === void 0 ? void 0 : payload.approvalBy,
            testPlaceId: payload === null || payload === void 0 ? void 0 : payload.testPlaceId,
            meetingSchedule: payload === null || payload === void 0 ? void 0 : payload.meetingSchedule,
            meetingLink: payload === null || payload === void 0 ? void 0 : payload.meetingLink,
            bnspScheduleCode: payload === null || payload === void 0 ? void 0 : payload.bnspScheduleCode
        };
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_LOADING, true);
            ApiService.put(`${API_URLS.getAll}/${employeeID}/${payload.assessmentId}/schedules?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed create TUK.' });
                reject(_response);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
            });
        });
    }
    [_m = Actions.GET_PA_SCHEDULE_AVAILABILITIES](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            hrgsSwalAlert({
                icon: 'error',
                text: 'Employee ID tidak ditemukan.'
            });
            return false;
        }
        const params = Object.assign(Object.assign(Object.assign({ ver: 'v1' }, ((payload === null || payload === void 0 ? void 0 : payload.assessorId) && { AssessorId: payload === null || payload === void 0 ? void 0 : payload.assessorId })), ((payload === null || payload === void 0 ? void 0 : payload.month) && { Month: payload === null || payload === void 0 ? void 0 : payload.month })), ((payload === null || payload === void 0 ? void 0 : payload.year) && { Year: payload === null || payload === void 0 ? void 0 : payload.year }));
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.getAll}/${employeeID}/schedules/availabilities?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch(() => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed Get Pre Assessment Schedule Availabilities'
                });
                reject();
            });
        });
    }
    // *EXPORT PREASSESSMENT SCHEDULE LIST DATA (CREATE/CHANGE)
    [_o = Actions.EXPORT_PA_SCHEDULE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            gmt: payload === null || payload === void 0 ? void 0 : payload.gmt
        };
        this.context.commit(Mutations.SET_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.getAll}/${employeeID}/export?${new URLSearchParams(Object.assign(Object.assign({}, params), this.getPANonNullFilter)).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                this.context.commit(Mutations.SET_LOADING, false);
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            });
        });
    }
    // *DOWNLOAD PREASSESSMENT SCHEDULE LIST DATA
    [_p = Actions.DOWNLOAD_PA_SCHEDULE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.getAll}/${employeeID}/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _h, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _j, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _k, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _l, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _o, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterPreAssessmentListModule.prototype, _p, null);
MasterPreAssessmentListModule = __decorate([
    Module
], MasterPreAssessmentListModule);
export default MasterPreAssessmentListModule;
